import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-youtube-recharge-tip-modal',
  templateUrl: './youtube-recharge-tip-modal.component.html',
  styleUrls: ['./youtube-recharge-tip-modal.component.scss'],
})
export class YoutubeRechargeTipModalComponent {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<YoutubeRechargeTipModalComponent>
  ) {}

  goto(url: string) {
    this.dialogRef.close();
    this.router.navigate([url]);
  }
}
